import Assignees from './Assignees';

export default Assignees;